type SerializedAdSpend = { adSpend: number; campaignId: number };

export const getInitialSessionBudget = () => {
  const serialized = sessionStorage.getItem('adSpend');
  if (!serialized) return;

  try {
    const deserialized = JSON.parse(serialized) as SerializedAdSpend[]; // TODO: improve type checking

    const mapped = deserialized.reduce(
      (accumulator, entry) => {
        accumulator[entry.campaignId] = entry.adSpend;

        return accumulator;
      },
      {} as Record<number, number>
    );

    return mapped;
  } catch {
    console.error('Unable to parse stored session budget!');
    return undefined;
  }
};
